import { TAX_RATES } from "./taxRates";

/**
 * Returns the applicable tax rate based on the given amount.
 *
 * - If the amount is less than or equal to the room threshold, the low rate applies.
 * - If the amount is greater than the room threshold, the high rate applies.
 *
 * @param {number} amount - The room charge amount.
 * @returns {number} The applicable tax percentage (either 5 or 18).
 */
export const getTaxRateForAmount = (amount) => {
  return amount <= TAX_RATES.ROOM.THRESHOLD
    ? TAX_RATES.ROOM.LOW.PERCENT
    : TAX_RATES.ROOM.HIGH.PERCENT;
};
